// Screenshot carousel on project pages. Without JS the track is still a
// swipeable scroll-snap strip; this adds the prev/next controls and folio.
const setupCarousel = (carousel) => {
  const track = carousel.querySelector("[data-carousel-track]")
  const slides = track ? Array.from(track.children) : []
  const bar = carousel.querySelector("[data-carousel-bar]")
  const current = carousel.querySelector("[data-carousel-current]")
  const prev = carousel.querySelector("[data-carousel-prev]")
  const next = carousel.querySelector("[data-carousel-next]")
  if (!track || !bar || slides.length < 2) return

  bar.hidden = false
  let index = 0

  const update = () => {
    current.textContent = index + 1
    prev.disabled = index === 0
    next.disabled = index === slides.length - 1
  }

  const goTo = (i) => {
    index = Math.max(0, Math.min(slides.length - 1, i))
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    track.scrollTo({ left: slides[index].offsetLeft, behavior: reduced ? "auto" : "smooth" })
    update()
  }

  prev.addEventListener("click", () => goTo(index - 1))
  next.addEventListener("click", () => goTo(index + 1))

  track.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") { e.preventDefault(); goTo(index - 1) }
    if (e.key === "ArrowRight") { e.preventDefault(); goTo(index + 1) }
  })

  let scrollTimer
  track.addEventListener("scroll", () => {
    clearTimeout(scrollTimer)
    scrollTimer = setTimeout(() => {
      let nearest = 0
      let best = Infinity
      slides.forEach((slide, i) => {
        const d = Math.abs(slide.offsetLeft - track.scrollLeft)
        if (d < best) { best = d; nearest = i }
      })
      if (nearest !== index) { index = nearest; update() }
    }, 80)
  }, { passive: true })

  update()
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-carousel]").forEach(setupCarousel)

  // Start the contribution graph scrolled to the most recent weeks
  document.querySelectorAll(".contrib-scroll").forEach((el) => {
    el.scrollLeft = el.scrollWidth
  })
})
